import React, { useState } from 'react';
// IMPORTAÇÃO DO ÍCONE STAR E A NOVA TELA
import { FileBarChart, Users, Building, ExternalLink, Layers, Star, Tag } from 'lucide-react';

import RelatoriosScreen from './RelatoriosScreen';
import RelatoriosClientesScreen from './RelatoriosClientesScreen';
import RelatoriosEmpresasScreen from './RelatoriosEmpresasScreen';
import RelatoriosExternosScreen from './RelatoriosExternosScreen';
import RelatoriosSetoresScreen from './RelatoriosSetoresScreen';
import RelatoriosAvaliacoesScreen from './RelatoriosAvaliacoesScreen';
import RelatoriosCategoriasScreen from './RelatoriosCategoriasScreen';

const RelatoriosContainer = ({ currentUser, users, clients }) => {
    const [activeTab, setActiveTab] = useState('team');

    return (
        <div className="flex flex-col h-full bg-gray-50">
            {/* ESTILOS PARA ESCONDER BARRA DE ROLAGEM */}
            <style>{`
                .hide-scrollbar-children > div::-webkit-scrollbar { display: none; }
                .hide-scrollbar-children > div { -ms-overflow-style: none; scrollbar-width: none; }
                .hide-scrollbar-x::-webkit-scrollbar { display: none; }
                .hide-scrollbar-x { -ms-overflow-style: none; scrollbar-width: none; }
            `}</style>

            <div className="bg-white border-b border-gray-200 px-8 pt-6">
                <h1 className="text-2xl font-bold text-gray-800 mb-6">Central de Relatórios</h1>

                <div className="flex overflow-x-auto hide-scrollbar-x">
                    <nav className="-mb-px flex space-x-8 min-w-max">

                        {/* ABA 1: EQUIPE */}
                        {(!currentUser?.permissions?.block_reports_team) && (
                            <button
                                onClick={() => setActiveTab('team')}
                                className={`pb-4 px-1 border-b-2 font-medium text-sm flex items-center transition-colors ${activeTab === 'team'
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }`}
                            >
                                <FileBarChart className="w-5 h-5 mr-2" /> Equipe
                            </button>
                        )}

                        {/* ABA NOVA: AVALIAÇÕES */}
                        {(!currentUser?.permissions?.block_reports_evaluations) && (
                            <button
                                onClick={() => setActiveTab('ratings')}
                                className={`pb-4 px-1 border-b-2 font-medium text-sm flex items-center transition-colors ${activeTab === 'ratings'
                                    ? 'border-yellow-500 text-yellow-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }`}
                            >
                                <Star className="w-5 h-5 mr-2" /> Avaliações
                            </button>
                        )}

                        {/* ABA 2: POR CLIENTE */}
                        {(!currentUser?.permissions?.block_reports_clients) && (
                            <button
                                onClick={() => setActiveTab('clients')}
                                className={`pb-4 px-1 border-b-2 font-medium text-sm flex items-center transition-colors ${activeTab === 'clients'
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }`}
                            >
                                <Users className="w-5 h-5 mr-2" /> Por Cliente
                            </button>
                        )}

                        {/* ABA 3: POR EMPRESA */}
                        {(!currentUser?.permissions?.block_reports_companies) && (
                            <button
                                onClick={() => setActiveTab('companies')}
                                className={`pb-4 px-1 border-b-2 font-medium text-sm flex items-center transition-colors ${activeTab === 'companies'
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }`}
                            >
                                <Building className="w-5 h-5 mr-2" /> Por Empresa
                            </button>
                        )}

                        {/* ABA 4: SETORES */}
                        {(!currentUser?.permissions?.block_reports_sectors) && (
                            <button
                                onClick={() => setActiveTab('sectors')}
                                className={`pb-4 px-1 border-b-2 font-medium text-sm flex items-center transition-colors ${activeTab === 'sectors'
                                    ? 'border-indigo-500 text-indigo-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }`}
                            >
                                <Layers className="w-5 h-5 mr-2" /> Setores
                            </button>
                        )}

                        {/* ABA NOVA: CATEGORIAS */}
                        {(!currentUser?.permissions?.block_reports_categories) && (
                            <button
                                onClick={() => setActiveTab('categories')}
                                className={`pb-4 px-1 border-b-2 font-medium text-sm flex items-center transition-colors ${activeTab === 'categories'
                                    ? 'border-blue-500 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }`}
                            >
                                <Tag className="w-5 h-5 mr-2" /> Por Categoria
                            </button>
                        )}

                        {/* ABA 5: ATENDIMENTO EXTERNO */}
                        {(!currentUser?.permissions?.block_reports_external) && (
                            <button
                                onClick={() => setActiveTab('external')}
                                className={`pb-4 px-1 border-b-2 font-medium text-sm flex items-center transition-colors ${activeTab === 'external'
                                    ? 'border-purple-500 text-purple-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }`}
                            >
                                <ExternalLink className="w-5 h-5 mr-2" /> Atend. Externo
                            </button>
                        )}

                    </nav>
                </div>
            </div>

            {/* CONTEÚDO DA ABA SELECIONADA */}
            <div className="flex-1 overflow-hidden relative hide-scrollbar-children">
                {activeTab === 'team' && (
                    <RelatoriosScreen currentUser={currentUser} users={users} clients={clients} />
                )}
                {/* RENDERIZAÇÃO DA NOVA TELA */}
                {activeTab === 'ratings' && (
                    <RelatoriosAvaliacoesScreen currentUser={currentUser} users={users} />
                )}
                {activeTab === 'clients' && (
                    <RelatoriosClientesScreen currentUser={currentUser} clients={clients} />
                )}
                {activeTab === 'companies' && (
                    <RelatoriosEmpresasScreen currentUser={currentUser} clients={clients} />
                )}
                {activeTab === 'sectors' && (
                    <RelatoriosSetoresScreen currentUser={currentUser} />
                )}
                {activeTab === 'categories' && (
                    <RelatoriosCategoriasScreen currentUser={currentUser} />
                )}
                {activeTab === 'external' && (
                    <RelatoriosExternosScreen currentUser={currentUser} clients={clients} />
                )}
            </div>
        </div>
    );
};

export default RelatoriosContainer;